import { View, Text, StyleSheet } from "react-native";
//import Ionicons from "react-native-vector-icons/Ionicons";
import { Ionicons } from "./VectorIcons";
import { getSchemeStyle } from "../context/helper";

const InfoField = ({ label, style }) => {
  const schemeStyles = getSchemeStyle();

  return (
    <View style={styles.infoContainer}>
      <View style={style}>
        <View style={[styles.infoContent,schemeStyles.Border]}>
          <Ionicons name="information-circle-outline" size={24} color="#666" />
          <Text style={styles.infoText}>{label}</Text>
        </View>
      </View>
    </View>
  );
};
export default InfoField;

const styles = StyleSheet.create({
  infoContainer: {
    position: "absolute",
    top: 10,
    left: 0,
    right: 0,
    flexDirection: "row",
    justifyContent: "center",
  },
  infoContent: {
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
    paddingVertical: 10,
    flexDirection: "row",
    alignItems: "center",
  },
  infoText: {
    fontFamily: "Roboto-Regular",
    fontSize: 16,
    marginLeft: 5,
    color: "#555",
  },
});
